module.exports = __webpack_public_path__ + "img/SR.9529c909.svg";